import { DropdownItemProps } from '@instinet-analytics/semantic-ui-components';
import {
    earliestArrivalLabel,
    individualArrivalLabel,
    lastLabel,
    PnlBenchmark,
} from 'utils/PnL';
import { xVwapLabel } from 'widgets/fillsGraph/legend/labels';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import React, { useCallback } from 'react';
import { useFillsGraphConfigurationSelector } from 'widgets/fillsGraph/store/configuration/selectors';
import { useDispatchUpdateFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/dispatcher';
import { FillsChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';

export interface PLBenchmarkDropdownProps {
    inlineToolbar?: boolean;
}

export function PLBenchmarkDropdown(props: PLBenchmarkDropdownProps) {
    const { inlineToolbar } = props;
    const config = useFillsGraphConfigurationSelector();
    const updateConfig = useDispatchUpdateFillsGraphConfiguration();

    const { [FillsChartType.PnL]: pnlConfig } = config;

    const pnlBenchmarkDropdownValues: DropdownItemProps[] = [
        {
            text: individualArrivalLabel,
            value: PnlBenchmark.IndividualOrderArrival,
        },
        {
            text: earliestArrivalLabel,
            value: PnlBenchmark.Arrival,
        },
        {
            text: xVwapLabel,
            value: PnlBenchmark.Vwap,
        },
        {
            text: lastLabel,
            value: PnlBenchmark.Last,
        },
    ];

    const onChange = useCallback(
        (pnlChartBenchmark: PnlBenchmark) => {
            updateConfig({
                ...config,
                [FillsChartType.PnL]: {
                    ...pnlConfig,
                    pnlChartBenchmark,
                },
            });
        },
        [config, pnlConfig, updateConfig]
    );

    return (
        <Dropdown
            className="PLBenchmarkDropdown"
            options={pnlBenchmarkDropdownValues}
            value={pnlConfig.pnlChartBenchmark}
            onChange={onChange}
            inlineToolbar={inlineToolbar}
        />
    );
}
